import DateRefresher from "date-refresher";

import CF from "./common-functions";
import cars from "./cars-info";

let date = CF.getDateString();

const PHONE = "+7 (495) 165-75-58";
const PHONE_RAW = PHONE.replace(/(?!^\+)\D+/g, "");

const baseDate = new Date(2026, 9, 21, 0, 0, 0); 
const now = new Date();
const diffMs = Math.max(0, now.getTime() - baseDate.getTime());
const MS_IN_3_DAYS = 4 * 24 * 60 * 60 * 1000;
const currentStep = Math.floor(diffMs / MS_IN_3_DAYS);
const start = new Date(baseDate.getTime() + (currentStep * MS_IN_3_DAYS));
const end = new Date(start.getTime() + MS_IN_3_DAYS - 1000); 


export default {
  address: "г. Химки, Ленинградское шоссе, вл.18",
  phone: PHONE,
  phone_raw: PHONE_RAW,
  worktime: "Ежедневно с 9:00-21:00",
  coords: {
    x_center_big: 37.420823,
    x_center_small: 37.420823,
    y_center: 55.899497,
    x_salon: 37.420823,
    y_salon: 55.899497,
  },
  end_day: date.split(" ")[0],
  end_month: date.split(" ")[1],
  end_date: DateRefresher.updateByInterval("11.03.2026", 3, "00:00"),
  salon_name: "GEELY Автомир Химки",
  teh_name: "GEELY Автомир Химки",
  dealer_name: "Автомир Химки",
  site: "geely-avtomir.ru",
  yur_name: "Автомир-Трейд",
  dealer_phone: '+7 (495) 182-00-82',
  need_agreement: true,
  cKeeper: "ctw",
  period: {
    start,
    end,
  },
};